import { JobsTbdSdk, EagerJobsTbdSdk, LazyJobsTbdSdk } from './types';

export const isLazySDK = (sdk: JobsTbdSdk): sdk is LazyJobsTbdSdk => 'loadJobData' in sdk;
export const isEagerSDK = (sdk: JobsTbdSdk): sdk is EagerJobsTbdSdk => 'jobCallbacks' in sdk;
